import { render, staticRenderFns } from "./Dibs.vue?vue&type=template&id=2adfac12&"
import script from "./Dibs.vue?vue&type=script&lang=js&"
export * from "./Dibs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports